import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { SessionService } from '../services/session-service'
import { errorToast } from '../toaster'
import { donePromise } from '../utils'

@Injectable({providedIn: 'root'})
export class SessionActions {
  constructor(private sessionService: SessionService) {}

  public signOut(): Promise<any> {
    let p = this.sessionService.signOut().then(() => {
      reactor.reset()
      if (window) window.location.pathname = '/'
    })
    .catch((e) => {
      errorToast('An error occurred while signing out')
    })
    return donePromise(p)
  }
}
